import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormView } from '@form/cer-form-view';
import { CerFormPanesSettingsUtil } from '@form/cer-form-panes/cer-form-panes.service';

export class RouteForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet): void {

    viewSet.panes = CerFormPanesSettingsUtil.masterDetail('vertical');

    var appRoute = RouteForm.viewAppRoute();
    viewSet.viewAdd(appRoute);

    viewSet.viewAdd(RouteForm.viewAppUserRoute('id','routeId'),appRoute);
  }

  private static viewAppRoute(): CerFormView {
    var view = new CerFormView();
    view.viewMetadata = {
      name: 'menupunkter', dataApiName: 'AppRoute', text: 'Menupunkter', textSingular: 'Menupunkt',
      primaryKey: 'id', allowEdit: true, allowCreate: false, allowDelete: false, baseFields: ['id', 'history']
    };

    view.fieldMetadata = [
      { name: 'url', text: 'URL', allowEdit: false, orderBy: 'Ascending' },
      { name: 'titel', text: 'Overskrift' }
    ];
    return view;
  }

  private static viewAppUserRoute(parentPrimaryKey: string, parentForeignKey: string): CerFormView {
    var view = new CerFormView();
    view.viewMetadata = {
      name: 'menupunkt-brugere', dataApiName: 'AppUserRoute', text: 'Brugere', textSingular: 'Bruger',
      primaryKey: 'id', parentPrimaryKey: parentPrimaryKey, parentForeignKey: parentForeignKey, allowEdit: true, allowCreate: false, allowDelete: true, baseFields: ['id', 'history']
    };

    view.fieldMetadata =
      [
        { name: 'userId', text: 'Bruger', foreignKeyTableName: "User", foreignKeyValue: "shortName", allowEdit: false },
        { name: 'routeId', text: 'Menupunkt', foreignKeyTableName: "AppRoute", allowEdit: false, visible: false },
        { name: 'defaultView', text: 'Visning valgt ved opstart' }
      ];

    //const uiCmdViews: UiCommand = { id: 'Views', text: 'Visninger', iconCss: CerUiIcons.open, target: ".e-content", needSelection: true };
    //view.toolbarCommands = [uiCmdViews];
    return view;
  }

}
